import React from "react";
import "./Footer.css";
import logo from '../assets/logo192.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* FaceLead Logo and Copyright */}
        <div className="footer-logo-text">
          <img src={logo} alt="FaceLead Logo" className="footer-logo" />
          <span>© 2024 FaceLead</span>
        </div>

        {/* Footer Links */}
        <div className="footer-links">
          <a href="/contact">Contact</a>
          <a href="/legal">Legal</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
